import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

const SMS = () => {
  const schema = useMemo(
    () => ({
      datetime: {
        label: 'Datum & Uhrzeit',
        type: 'date',
        readOnly: true,
        displayValue: v => {
          try {
            const d = new Date(v);
            if (Number.isNaN(d.getTime())) return '—';
            return d.toLocaleString();
          } catch {
            return '—';
          }
        },
      },
      externalStatus: {
        label: 'External Status',
        type: 'text',
        readOnly: true,
        truncate: 40,
      },
      receiver: {
        label: 'Empfänger',
        type: 'text',
        readOnly: true,
        truncate: 40,
      },
      text: {
        label: 'Text',
        type: 'text',
        readOnly: true,
        previewInList: true,
        previewMaxLines: 1,
        truncate: 140,
      },
    }),
    []
  );

  return (
    <Box sx={viewRootTextPrimarySx}>
    <EditableList
      title='Gesendete SMS'
      resourceType='sentShortMessage'
      schema={schema}
      visibleColumnKeys={['datetime', 'externalStatus', 'receiver', 'text']}
      hideColumnSelector={true}
      parentIsEditable={false}
      searchPlaceholder='SMS durchsuchen...'
      options={{
        disableCreate: true,
        disableDelete: true,
        disableDetailView: true,
        listConfig: {
          pageParam: '_page',
          limitParam: '_limit',
        },
      }}
    />
    </Box>
  );
};

export default SMS;
